import { ISuggestionGroup } from '../../../../../types/suggestions';

export const getUndergroundColors = (suggest: ISuggestionGroup): string[] | undefined => {
  if (suggest.type === 'underground' && suggest.undergroundLines) {
    return suggest.undergroundLines.map(line => line.lineColor);
  }

  return undefined;
};
